import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { SortDirection } from '@angular/material/sort';
import { AuthService } from 'src/app/utility/auth/auth.service';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class LogListComponent implements OnInit {

  pageAble = {
    sortKeyword : 'lastAccessTime',
    sortOrder : 'desc',
    pageNumber : 0,
    pageSize : 10
  };
  search: string = '';

  totalElements: number;

  displayedColumns = ['number', 'userId', 'status', 'lastAccessTime'];
  dataSource;

  selectOptions = ['전체', '제목', '내용'];
	selectedOption = this.selectOptions[0];

  constructor(
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.doRefresh();
  }

  doRefresh() {
    this.getAuthSession();
  }

  getAuthSession() {
    this.authService.getAuthSession(this.pageAble, this.search).subscribe(res => {
      this.totalElements = res.totalElements;
      this.dataSource = res.content;
    })
  }

  public pageChangeEvent(event: PageEvent) {
    this.pageAble.pageNumber = event.pageIndex;
    this.pageAble.pageSize = event.pageSize;
    this.doRefresh();
  };

  public doSort(sortItem : string) {
    if(this.pageAble.sortKeyword === sortItem) {
      if(this.pageAble.sortOrder === 'desc'){
        this.pageAble.sortOrder = 'asc' as SortDirection;
      } else {
        this.pageAble.sortOrder = 'desc' as SortDirection;
      };
    } else {
      this.pageAble.sortKeyword = sortItem;
      this.pageAble.sortOrder = 'asc' as SortDirection;
    };
    this.doRefresh();
  };

	public clear(event) {
		if (event.keyCode === 8) {
		  if (this.search === '') {
			this.doRefresh();
		  }
		} else {
		  this.search = ''
		  this.doRefresh();
		}
	}
}
